import React, { useContext, useMemo } from 'react';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import { languages } from 'utils/languages';
import MainContext from 'MainContext';
import styled from 'styled-components';

const DateWrapper = styled.span`
display:inline-block; 
direction:ltr;
`

const Input = (props) => {
  const { language } = useContext(MainContext).login.shop_profile;

  const { value, showRelative, withTime } = props;

  const { toolTip, dateShown } = useMemo(() => {
    const UTCDate = moment.utc(value);
    let date = UTCDate.clone().local();
    const isOlderThanOneDay = moment().diff(date, 'days') > 1;
    let formatString = withTime ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD';

    if (languages[language].value === 'fa') {
      date = momentJalaali(value);
      formatString = withTime ? 'jYYYY/jMM/jDD HH:mm' : 'jYYYY/jMM/jDD';
    }

    return {
      toolTip: `UTC: ${UTCDate.format("YYYY/MM/DD HH:mm")}`,
      dateShown: (showRelative && !isOlderThanOneDay)
        ? date.fromNow()
        : date.format(formatString)
    };
  }, [value, showRelative, withTime]);

  return (
    <DateWrapper title={toolTip}>
      {dateShown}
    </DateWrapper>
  );
};

export default Input;
